var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseMenu = function SvgCloseMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35,
    rx: 4,
    fill: "#E0F0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3744 23.7314L12.4107 10.7678C12.0855 10.4425 12.0855 9.91453 12.4107 9.58926C12.736 9.26399 13.264 9.26399 13.5893 9.58926L26.5529 22.5529C26.8781 22.8781 26.8781 23.4061 26.5529 23.7314C26.2276 24.0567 25.6996 24.0567 25.3744 23.7314Z",
    fill: "#4DA54B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7314 10.6256L13.7678 23.5893C13.4425 23.9145 12.9145 23.9145 12.5893 23.5893C12.264 23.264 12.264 22.736 12.5893 22.4107L25.5529 9.44712C25.8781 9.12185 26.4061 9.12185 26.7314 9.44712C27.0567 9.77239 27.0567 10.3004 26.7314 10.6256Z",
    fill: "#4DA54B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close_menu.9f667e91.svg";
export { ForwardRef as ReactComponent };